module.exports = __webpack_public_path__ + "media/images/about-e133eddd79d10881ecace4643c957545.png";